/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Row, Col, Dropdown, Menu, message, Empty } from "antd";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Moment from "react-moment";
import { getProfileDetails } from "../../actionsMethods/masterMethods";
import bell from "../../assests/images/bell.svg";
import clock from "../../assests/images/timerIcon.svg";
import appLogo from "../../assests/images/smcsLogo.svg";
import mobileLogo from "../../assests/images/shree-maruti-logo.svg";
import calender from "../../assests/images/calenderIcon.svg";
import checkMark from "../../assests/images/SVG/check.svg";
import hamIcon from "../../assests/images/maruti/hamburgerIcon.svg";
import mail from "../../assests/images/mail.svg";
import cart from "../../assests/images/cart.svg";
import urls from "../../api/urls";
import API from "../../api";
const { GET_NOTIFICATION, VIEW_NOTIFICATION, GET_CART_DETAILS } = urls;
import "./style.scss";
import { APIs } from "../../utils/worker";
const { baseURL } = APIs;
import { loginUserClear } from "../../actionsMethods/cashBookingMethods";
import axios from "axios";

const AppHeader = ({ showLogo, handleOpenDrawer = () => {} }) => {
  const navigate = useNavigate();
  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const [dateToFormat, setdateToFormat] = useState(new Date());
  const [userName, setUserName] = useState();
  const [cartDetails, setCartDetails] = useState(0);
  const [role, setRole] = useState(false);
  const [items, setItems] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  let eventSource = undefined;
  let dispatch = useDispatch();

  // useEffect(() => {
  //   initialize();
  // }, []);
  // useEffect(() => {
  //   let userinfo = JSON.parse(localStorage.getItem("userinfo"));
  //   if (userinfo.roles.includes("ROLE_HOADMIN")) {
  //     setRole(true);
  //   } else {
  //     setRole(false);
  //   }
  //   getCartDetails();
  // }, []);
  const getCartDetails = async () => {
    let response = await API.Api(GET_CART_DETAILS).getWithUserNPremiseHeader();
    if (response.status) {
      localStorage.setItem(
        "cartDetails",
        JSON.stringify(response?.response?.data?.items.length)
      );
      setCartDetails(response?.response?.data?.items.length);
    }
  };
  let userid = JSON.parse(localStorage.getItem("userId"));
  let item0List = [
    {
      label: (
        <div className="space-between">
          <span className="fw-600">Notifications</span>
          <img src={mail} />
        </div>
      ),
      key: "0",
    },
    { type: "divider" },
  ];
  const initialize = async () => {
    // if (open) {
    // let response = await API.Api(
    //   GET_NOTIFICATION + userid?.userInfo?.userId
    // ).get();
    eventSource = new EventSource(
      `${baseURL}/notification-service/stream-flux/${userid?.userInfo?.userId}`
    );

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setNotificationList(data);
      data.sort(
        (a, b) =>
          a.viewed.toString().charCodeAt(0) - b.viewed.toString().charCodeAt(0)
      );
      let item = [];
      let item1 = {};
      if (data.length > 0) {
        data.map((e, i) => {
          if (i < 4) {
            item.push(
              {
                label: (
                  <div
                    onClick={() => viewNotification(e.notificationId, e.viewed)}
                  >
                    <span
                      style={{ color: "#202124" }}
                      className="space-between align-center"
                    >
                      <span>{e.notificationTitle}</span>

                      <span
                        className="notifiaction-viewed"
                        style={{
                          background: e.viewed ? "#D2D2D2" : "#EC3E3E",
                        }}
                      ></span>
                    </span>
                    <span style={{ marginTop: "-1rem", color: "#878787" }}>
                      {e.notificationCreatedDate}
                    </span>
                  </div>
                ),
                key: e.id,
              },
              { type: "divider" }
            );
          }
        });
        item1 = {
          label: (
            <span
              className="center"
              style={{ color: "#2E77D0" }}
              onClick={() => navigate("/notification")}
            >
              View all Notifications
            </span>
          ),
          key: "notification",
        };
      } else {
        item.push({ label: <Empty />, key: "empty" });
      }

      setItems([...item0List, ...item, item1]);
    };
    eventSource.onerror = (err) => {
      console.error("EventSource failed:", err);
      eventSource.close();
    };

    //}
  };

  const viewNotification = async (id, viewed) => {
    if (viewed) {
      navigate("/notification");
    } else {
      let response = await API.Api(VIEW_NOTIFICATION).putIdHeader({
        notificationId: id,
      });
      if (response?.status) {
        navigate("/notification", { state: id });
      } else {
        message.error("Network error.");
      }
    }
  };

  const profileDetails = useSelector(
    (state) => state.masterReducer.getProfileDetailsReducer,
    shallowEqual
  );
  const { result: profileDetailsResult } = profileDetails;

  useEffect(() => {
    if (profileDetailsResult) {
      setUserName(profileDetailsResult?.data.firstName);
    }
  }, [profileDetailsResult]);

  useEffect(() => {
    let userName = JSON.parse(localStorage.getItem("userName"));
    setUserName(userName);
  }, [localStorage.getItem("userName")]);

  useEffect(() => {
    setInterval(() => {
      let cartDetails = JSON.parse(localStorage.getItem("cartDetails"));
      setCartDetails(cartDetails ? cartDetails : 0);
    }, 1000);
  }, [localStorage.getItem("cartDetails")]);

  useEffect(() => {
    setInterval(() => setdateToFormat(new Date()), 30000);
  }, []);

  // const apiTriger = () => {
  //   setLoading(true);
  //   let userData = JSON.parse(localStorage.getItem("userinfo"));
  //   const headers = {
  //     Authorization: "Bearer " + userData.accessToken,
  //     loginEmailId: userData?.emailId,
  //   };

  //   axios
  //     .get(
  //       `${APIs.baseURL}/cp-onboarding/v1/getCpDetail/${history?.state?.id}`,
  //       {
  //         headers: headers,
  //       }
  //     )
  //     .then((response) => {
  //       setApiResponse(response.data);
  //       // if (response.status == 200) {
  //       //   setApiResponse(response.data);
  //       //   return axios
  //       //     .get(
  //       //       `${APIs.baseURL}/premise-service/v1/premises/${response?.data?.premiseDetails?.parentId}`,
  //       //       {
  //       //         headers: headers,
  //       //       }
  //       //     )
  //       //     .then((res) => {
  //       //       if (res.status == 200) {
  //       //         setMotherHubName(res?.data?.premiseName);
  //       //         setLoading(false);
  //       //       }
  //       //     });
  //       // }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const menuClicked = ({ key }) => {
    const headers = {
      Authorization: "Bearer " + userData.accessToken,
      loginEmailId: userData?.emailId,
    };

    axios
      .get(`${APIs.baseURL}/cp-onboarding/v1/logout`, {
        headers: headers,
      })
      .then((response) => {
        // setApiResponse(response.data);
        console.log(response);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    dispatch(loginUserClear());

    localStorage.removeItem("userinfo");
    window.location.replace("/");
    // navigate("/");
  };

  const menu = (
    <Menu
      className="nav-dropdown-a"
      onClick={menuClicked}
      items={[
        // {
        //   label: userName,
        //   key: "1",
        //   style: { fontSize: "14px" },
        // },
        // {
        //   type: "divider",
        // },
        // {
        //   label: "Profile",
        //   key: "2",
        //   style: { fontSize: "14px" },
        //   icon: <UserOutlined />,
        //   disabled: false,
        // },
        // {
        //   label: "Settings",
        //   key: "3",
        //   style: { fontSize: "14px" },
        //   icon: <SettingOutlined />,
        //   disabled: true,
        // },
        {
          label: "Logout",
          key: "4",
          style: { fontSize: "14px" },
          icon: <LogoutOutlined />,
        },
      ]}
    />
  );

  function MyComponent() {
    const toUpperCaseFilter = (d) => {
      return d.slice(0, 15);
    };
    return <Moment filter={toUpperCaseFilter}>{dateToFormat}</Moment>;
  }

  let time = dateToFormat.toLocaleString("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  });

  const [rectColor, rectColorSet] = useState("red");

  useEffect(() => {
    if (rectColor === "red" || rectColor === "#1890ff") {
      const timeoutID = setTimeout(() => {
        rectColorSet(rectColor === "red" ? "#1890ff" : "red");
      }, 1000);
      return () => clearTimeout(timeoutID);
    }
  });

  return (
    <div className="header">
      <div className="header-content">
        <div className="d-flex space-between">
          <div className="space-between">
            <img
              src={hamIcon}
              className="mr-1 ham-mobile"
              // onClick={handleOpenDrawer}
            />
            {/* {showLogo && ( */}
            <div className="banner">
              <img src={appLogo} className="web-logo" />
              <img src={mobileLogo} className="mobile-logo" />
            </div>
            {/* )} */}
          </div>
          <div className="align-center">
            <div
              className="time pr-1 align-center mr-1"
              style={{ border: "2px solid #dddddd" }}
            >
              {/* <img src={calender} /> */}
              <span>
                <span style={{ fontWeight: "500" }}>
                  {" "}
                  CP onboarding tutorial :
                </span>
                <a
                  href="https://youtu.be/dylxtbTOo5Q"
                  target="_blank"
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: rectColor,
                  }}
                  // id="li1"
                >
                  &#160; हिंदी
                </a>{" "}
                |
                <a
                  href="https://youtu.be/L7artHInAQA"
                  target="_blank"
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: rectColor == "red" ? "#1890ff" : "red",
                  }}
                  // id="li1"
                >
                  &#160; English
                </a>
              </span>
              {/* <img src={clock} /> */}
              {/* <span>{time}</span> */}
            </div>
            <div className="time pr-1 align-center mr-1">
              <img src={calender} />
              <span>{MyComponent()}</span>
              <img src={clock} />
              <span>{time}</span>
            </div>

            <div className="profile1 d-flex center ml-1">
              <Dropdown overlay={menu} overlayClassName="nav-dropdown-overlay">
                <a>
                  {userData?.userName?.substring(1, 0).toUpperCase() || "?"}
                  {/* <img src={checkMark} className="profile-edit-img1" /> */}
                </a>
              </Dropdown>
            </div>
            {/* <div className="username letter">
              <Dropdown overlay={menu} overlayClassName="nav-dropdown-overlay">
                <>
                  <span style={{ fontSize: "15px" }}>
                    {userName?.substring(1, 0).toUpperCase() || "?"}
                  </span>
                  <img src={checkMark} />
                </>
              </Dropdown>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppHeader;
